import React, { Component } from 'react';
import style from './style/twofactorauthenticationform.scss';

export default class LoginForm extends Component {
    render() {
        const { onSubmit, handleChange, error, buttonDisabled, username, i18n, i18nPrefix, classes } = this.props;

        return (
            <div className={`${style.modal} ${classes.modal}`}>
                <section className={`${style.twoFactorAuthenticationForm} ${classes.twoFactorAuthenticationForm}`}>
                    <form className={`${classes.form || ''}`}>
                        <header className={style.modal_header}>
                            <h3>{i18n[`${i18nPrefix}_two_factor_authentication_title`]}</h3>
                        </header>
                        <main>
                            <div>
                                <label htmlFor="twoFactorAuthenticationCode">{i18n[`${i18nPrefix}_two_factor_authentication_label_a`]} {username}{i18n[`${i18nPrefix}_two_factor_authentication_label_b`]}</label>
                                <input
                                    data-cy="two-factor-authentication-code-input"
                                    tabIndex="1"
                                    type="text"
                                    maxLength="6"
                                    id="twoFactorAuthenticationCode"
                                    name="twoFactorAuthenticationCode"
                                    autoComplete="off"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <span className={style.errors}>
                                {error}
                            </span>
                        </main>
                        <footer className={style.modal_footer} >
                            <nav>
                                <button
                                    className={'action_button'}
                                    data-cy="two-factor-authentication-submit-button"
                                    disabled={buttonDisabled}
                                    onClick={onSubmit}
                                >
                                    {i18n[`${i18nPrefix}_two_factor_authentication_continue`]}
                                </button>
                            </nav>
                        </footer>
                    </form>
                </section>
            </div>
        );
    }
}
